import { NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'

import { Legend } from './components/LegendItem'
import { colors, MarketOverviewChart } from './components/MarketOverviewChart'
import { MarketOverviewContent } from './components/MarketOvierviewContent'
import { Token } from '@/domain/types/Token'
import { UsdAmountTooltip } from '@/ui/organisms/usd-amount-tooltip/UsdAmountTooltip'

export interface MarketOverviewProps {
  token: Token
  marketSize: NormalizedNumber
  borrowed: NormalizedNumber
  available: NormalizedNumber
  utilizationRate: Percentage
}

export function MarketOverview({ token, marketSize, borrowed, available, utilizationRate }: MarketOverviewProps) {
  const chartData = [
    { value: borrowed.toNumber(), color: colors.borrow },
    { value: available.toNumber(), color: colors.available },
  ]

  return (
    <MarketOverviewContent>
      <MarketOverviewChart
        data={chartData}
        token={token}
        marketSize={marketSize}
        borrowed={borrowed}
        utilizationRate={utilizationRate}
        className="max-w-md px-12"
      />
      <Legend>
        <Legend.Item variant="borrowed">
          <UsdAmountTooltip token={token} amount={borrowed} style="compact" />
        </Legend.Item>
        <Legend.Item variant="instantly-available">
          <UsdAmountTooltip token={token} amount={available} style="compact" />
        </Legend.Item>
      </Legend>
    </MarketOverviewContent>
  )
}
